var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "url(#pattern0)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_14_59",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_14_59",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACp0lEQVR4nO3ZsU5UQRjF8fORTSCrM5ea+ARqpIaSaGdHhY2dlFpSamlFtPMBNFJJoU+gDaWJjQ2JiaGwIGEWNtlkcz8baTCEvXt3ztybnF+7MHfyz7I5GwAREREREZGOspyHu/tKSmnXzJ4AuAfgVs7nzeECwA93/xBjfGdmk1wPyhZ6PB7fmU6nXwA8yPWMBfs+GAweD4fD3zkOX8pxqLuv9CwyAKxPp9PP7r6c4/AsoVNKu+hX5EvrKaVnOQ7OEvrfZ3Iv5bp7ltAA7mY6l+F+jkNzhb6d6VyGLHfPFVquUGgShSZRaBKFJlFoEoUmUWgShSZRaBKFJlFoEoUmUWgShSZRaBKFJlFoEoUmUWgShSZRaBKFJlFoEoUmUWgShSZRaBKFJlFoEoUmUWgShSZRaBKFJlFoEoUmUWgShSZRaBKFJlFoEoUmUWiSvoV2AHvu/gJAXfoyTQxKX6CBiZk9DSEcAEBK6ZeZvXf3YemLzaIv7+hTAA8vIwNAjPGwrustAH/KXWt2fQh9DGAzxvjt6gtVVR3Vdb0B4Cf/Ws10PfSRmW3EGK8Nubq6euzumwC+Eu/VWJdDH56fn2+FEG78aKiq6jSE8MjdD2762VI6GdrM3oYQttfW1sYNfmcSY9xx91c57zavroV2AHshhOdm1ni+mZlXVfWyi/OvS6EnZrYTY3zd9qCqqt4A2Dazmf8icutK6P/mW1tdm39dCH3tfGurS/OvdOgb51tbXZl/JUPPPN/a6sL8KxJ6nvm2gGcWnX/s0K3mW1sl5x8z9MLmW1sl5h8r9MLnW1vs+ccInW2+tcWcf7lDZ59vbXVl/s0lpeQppU8nJye9+O8HALj78tnZ2ceUkpe+y8xGo9G+u5f+MtSYuy+NRqP90vcQERERERGh+gt7ktpnf25DdAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.f74e803d34b36ac151c04c9074018c04.svg";
export { ForwardRef as ReactComponent };